/**
 * Google Analytics Component
 * Handles page view tracking on route changes
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../../utils/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 on mount
    initGA();
  }, []);

  useEffect(() => {
    // Track page view on route change
    const path = location.pathname + location.search;
    const title = document.title || 'Werkix - Empowering African Tech Talent';
    trackPageView(path, title);
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
